/*
  色・サイズ選択時の URL 更新（?variant=…）を、画面の更新が終わった後に回す（2026-10-05 INP 対策）。

  theme.js の Variants._updateHistoryState は選択のたびに history.replaceState を呼ぶ。
  Meta・Google・Shopify の計測タグはこれを「ページ移動」とみなして処理を走らせるため、
  タップから画面が変わるまでの時間（INP）がその分だけ延びていた（計測で約 50ms／回・PC）。

  - URL 更新そのものはこれまでどおり行う（選択中のバリエーション付き URL は共有できる）。
  - 次の描画の後、さらに次のタスクで実行する。
  - 連続でタップされたときは最後の 1 回だけ実行する。

  theme.js（defer）の後に差し替える必要があるので、DOMContentLoaded で行う。
*/
(() => {
  const patch = () => {
    const Variants = window.theme && theme.Variants;
    if (!Variants || !Variants.prototype || Variants.prototype.__lfDeferredHistory) return;

    const original = Variants.prototype._updateHistoryState;
    if (typeof original !== 'function') return;

    let pending = null;
    let scheduled = false;

    const run = () => {
      scheduled = false;
      const job = pending;
      pending = null;
      if (job) original.call(job.self, job.variant);
    };

    Variants.prototype._updateHistoryState = function (variant) {
      pending = { self: this, variant };
      if (scheduled) return;
      scheduled = true;

      // 描画を 1 回通してから、別タスクで URL を更新する。
      requestAnimationFrame(() => window.setTimeout(run, 0));
    };

    Variants.prototype.__lfDeferredHistory = true;
  };

  // defer 実行時点では theme.js がまだ実行されていない（readyState は 'interactive'）。
  // DOMContentLoaded は defer スクリプトがすべて終わった後に来るので、そこで差し替える。
  if (document.readyState === 'complete') {
    patch();
  } else {
    document.addEventListener('DOMContentLoaded', patch);
    window.addEventListener('load', patch);
  }
})();
